
import React, {FC} from 'react';
import classNames from 'classnames';
import Button from 'components/Button';

import {onScrollTo} from '.';

import * as styles from './styles.module.scss';

export const SCAN_IMAGES_ANCHOR = 'SCAN_IMAGES';

const ImagesCard: FC<{date: string}> = ({date}) => {
	const asset = 'https://static.bodyspec.com/at/ea/88/ea88a62a0d5dafd0';
	return (
		<div className={styles.wrapper}>
			<div className={classNames(styles.top, styles.image)}>
				<Button variant='underline' onClick={onScrollTo(SCAN_IMAGES_ANCHOR)}>
					<div className={styles.title}>
						Scan images
					</div>
				</Button>

				{/* Explicitly NOT using DynamicAsset since
					This resource is already properly sized. */}
				<div className={styles.content}>
					<div onClick={onScrollTo(SCAN_IMAGES_ANCHOR)}>
						<img src={asset} />
					</div>
					<span>{date}</span>
				</div>
			</div>
		</div>
	);
};

export default ImagesCard;
